import React, { FC } from 'react';
import { CalculationsBlock } from './components/calculationsBlock';
import { RecommendedBlock } from './components/recommendedBlock';
import { WeightBlock } from './components/weightBlock';
import * as S from './styled';

export interface Props {
	isShowResults: boolean;
	currentWeightValue: number;
	goalWeightValue: number;
	weightUnit: string;
	monthsCount: number;
	goalDate: string;
}

export const ResultBlock: FC<Props> = props => {
	const { isShowResults, currentWeightValue, goalWeightValue, weightUnit, monthsCount, goalDate } =
		props;

	return (
		<S.Container isShowResults={isShowResults}>
			<S.Title>
				Get a new you by <span>{goalDate}!</span>
			</S.Title>
			<WeightBlock
				currentWeight={currentWeightValue}
				weightUnit={weightUnit}
				goalWeight={goalWeightValue}
				monthsCount={monthsCount}
				goalDate={goalDate}
			/>
			<CalculationsBlock
				goalWeight={goalWeightValue}
				currentWeight={currentWeightValue}
				weightUnit={weightUnit}
			/>
			<RecommendedBlock monthsCount={monthsCount} />
		</S.Container>
	);
};
